<template>
  <div>
    <button class="btn my-btn" @click="routerGo($event)">
      <div class="info-box" :class="wrapBgColor">
        <span class="info-box-icon" v-bind:class="bgColor">
          <i v-bind:class="bgIcon"></i>
        </span>
        <div class="info-box-content">
          <h6 class="info-box-title">{{title}}</h6>
          <span class="info-box-subtitle">{{subtitle}}</span>

          <div class="progress" v-if="isProgress">
            <div class="progress-bar" :style="`width: ${percentage}%`"></div>
          </div>
          <span class="progress-description">
            {{ progressDescription }}
          </span>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'VAInfoBox',
  props: {
    'wrapBgColor': {
      type: String
    },
    'bgColor': {
      type: String
    },
    'bgIcon': {
      type: String
    },
    'number': {
      type: Number,
      default: 0
    },
    'numberType': {
      type: String
    },
    'percentage': {
      type: Number,
      default: 0
    },
    'progressDescription': {
      type: String,
      default: ''
    },
    'isProgress': {
      type: Boolean,
      default: false
    },
    'title': {
      type: String,
      default: 'Title Box',
      require: true
    },
    'subtitle': {
      type: String,
      default: 'Subtitle Box'
    },
    'link': {
      type: String,
      default: '#'
    }
  },
  methods: {
    routerGo (e) {
      e.preventDefault()
      this.$router.push(this.link)
    }
  }
}
</script>

<style scoped>
.info-box-title {
  text-transform: uppercase;
  font-weight: bold;
}
.info-box-subtitle {

}
.my-btn {
  text-align: left;
  white-space: normal;
  padding: 0;
  width: 100%;
}
.my-btn:hover {
  color: #3c8dbc;
}

.info-box {
  box-shadow: 1px 1px 5px rgba(0,0,0,0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/VAInfoBox.vue